<template>
    <div class="eq-grid-cell-renderer p-2">
        <h4
            v-if="params.detailtitle"
            class="fs-6 m-0 p-0 ms-3"
        >
            {{ $tm(params.detailtitle) }}
        </h4>
        <component
            ref="comp"
            v-if="params.detailview"
            :is="params.detailview"
            :parentrow="params.data"
        ></component>
        <div v-else-if="params.detailgridsetup">
            <div class="ps-3">
                <GridComp
                    :grid-setup="params.detailgridsetup"
                    :parentrow="params.data"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts" generic="TRowData">
/**
 * This is a wrapper for the grid component that will be used as a cell renderer in the ag-grid.
 *
 * TODO: Do we need to register the grid as it says here, as we are not using the api for anything?
 * @see https://www.ag-grid.com/vue-data-grid/master-detail-custom-detail/
 *
 */
import { $tm } from '@/locize';
import type { GridSetup } from '../Classes';
import GridComp from '../GridComp.vue';
import { inject, onMounted, ref, type Component, type Ref } from 'vue';
import type { IGridDetailExposed } from '../Classes/IGridDetailExposed';
import type { ListCompState } from '@/components/List/ListCompState';

const props = defineProps<{
    params: {
        /**
         * Regular gridsetup, will be wrapped in a GridComp
         */
        detailgridsetup?: GridSetup<any>;

        /**
         * Title for the detailview
         */
        detailtitle?: string;

        /**
         * Detailview component.
         * @remarks this has to handle all the saving etc itself.
         */
        detailview?: Component & IGridDetailExposed<TRowData>;

        /**
         * that datarow of the parent grid
         */
        data: any;

        /**
         * The reigster funciton for the grid. This register all the detailgrids in the parent grid.
         */
        registerGrid: (detailgrid: IGridDetailExposed<TRowData>) => void;
    }; // TODO: Add type this contains the GridOptions<TRowData, TCell> . Can we actually find out the type, since this is passed throught the grid params?
}>();

const comp = ref<IGridDetailExposed<TRowData>>();

// Gives us a reference to the state of the parent list component.
// NOTE!: This might be bit of an issue if we have multiple levels of nested grids. But since we are only passing the state to the detailview, it should be fine sine it is the top level that matters.
const detailviewStatus = inject<Ref<ListCompState>>('ListCompState');

if (detailviewStatus === undefined) {
    throw new Error('The GridDetailCellRenderer needs to be inside a ListComp');
}

onMounted(() => {
    // Register a unique id for the grid
    // TODO: We need to create a wrapper for the GridComp if we use detailgridsetup that implement the IGridDetailExposed interface
    props.params.registerGrid(comp.value!);

    // Add the detailgrid to the parent grid
    detailviewStatus.value.DetailGrids.push(comp.value!);
});
</script>
